import { AppSyncError } from "../../../core/utils/aws/appsync/AppSyncError.js";

let sentryInitiated = false;
export async function initSentry(dsn: string, environment: string, release: string): Promise<void> {
	if (sentryInitiated || !import.meta.env.PROD) {
		return;
	}

	const Sentry = await import("@sentry/browser");
	Sentry.init({
		dsn,
		environment,
		release,
		tracesSampleRate: 1.0,
		replaysSessionSampleRate: 0.1,
		replaysOnErrorSampleRate: 1.0,
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration({
				maskAllText: false,
				maskAllInputs: false,
				blockAllMedia: false,
			}),
		],
		beforeSend(event, hint) {
			const exception = hint.originalException;

			if (exception instanceof AppSyncError) {
				event.fingerprint = ["{{ default }}", String(exception.name), String(exception.message)];
			}

			return event;
		},
	});

	// eslint-disable-next-line require-atomic-updates
	sentryInitiated = true;
}
